export default __webpack_public_path__ + "static/media/bauhaus-feedback-1.f4e3ee6e.png";